import { gql } from 'apollo-angular'

import { ORGANIZATION_FIELDS } from '../../fragments/organization.fragment'

export const CREATE_ORGANIZATION = gql`
  mutation CreateOrganization(
    $name: String!
    $streetName: String!
    $streetNumber: String
    $postalCode: String!
    $city: String!
    $country: Organization_country_MutationInput!
    $vatNumber: String
  ) {
    createOrganization(
      data: {
        name: $name
        streetName: $streetName
        streetNumber: $streetNumber
        postalCode: $postalCode
        city: $city
        country: $country
        vatNumber: $vatNumber
      }
    ) {
      ...OrganizationFields
    }
  }
  ${ORGANIZATION_FIELDS}
`
